
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ApiGateway, PageOptions, ViaAdministration } from 'cw-backend';
import { CwUtils } from 'cw-utils';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class ViaAdministrationListProvider implements Resolve<any> {
    viaAdministration: ViaAdministration[];
    viaAdministrationEdit: ViaAdministration;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        this.currentPage = this.state?.currentPage;
        this.viaAdministrationEdit = this.state?.currentViaAdministration;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        }
        else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = 'code';
        }
        return new Promise<void>((resolve, reject) => {
            Promise.all([
                this.getPage(this.pageOptions)
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    get(id: number): Observable<ViaAdministration> {
        if (!id) {
            return null;
        }
        return this.gw.get('viaAdministration/:id', { id: id });
    }

    get currentViaAdministration(): ViaAdministration {
        return this.viaAdministrationEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('viaAdministration/').subscribe((res: HttpResponse<any>) => {
                this.viaAdministration = res.body;
                resolve(res);
            }, reject);
        });

    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('viaAdministration/search', pageOptions).subscribe((res: HttpResponse<any>) => {
                if (!CwUtils.compare(this.viaAdministration, res.body.content) && res.body.content.length > 0) {
                    this.viaAdministration = res.body.content;
                    this.onDataChanged.next(this.viaAdministration);
                }
                else {
                    this.viaAdministration = res.body.content;
                };
                resolve(res);
            }, reject);
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}

